// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, switchMap } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { Expertise } from '../models/expertise';
import { BaseService } from './base.service';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class ExpertiseService extends BaseService {

  // Verify user credentials on server to get token
  getAll(sortField: string = 'name', sortOrder: number = 2, filters: any,
    first: number, rows: number): Observable<HttpResponse<any[]>> {

      let params = new HttpParams()
        .set('sort',((sortOrder===1) ? '' : '-') + sortField)
        .set('page', ((first/rows)+1).toString())
        .set('per-page', rows.toString())
        .set('expand', 'contact,address,baseUser,satelliteUser,type,workflow,collaborateurs,collaborateurs.user');
          for (let a in filters) {
      params = params.set(a,filters[a].value);
    }
    return this.http
      .get<any>(this.basePath + '/v1/expertises', {params: params,  observe: 'response'})
      .pipe(
        catchError(this.handleError)
      );
  }

  
  // Verify user credentials on server to get token
  getAllLight(sortField: string = 'name', sortOrder: number = 1, filters: any,
    first: number, rows: number): Observable<HttpResponse<any[]>> {

      let params = new HttpParams()
        .set('sort',((sortOrder===1) ? '' : '-') + sortField)
        .set('page', ((first/rows)+1).toString())
        .set('per-page', rows.toString())
        ;
          for (let a in filters) {
      params = params.set(a,filters[a].value);
    }
    return this.http
      .get<any>(this.basePath + '/v1/expertises', {params: params,  observe: 'response'})
      .pipe(
        catchError(this.handleError)
      );
  }
  get(id: number): Observable<Expertise> {
    return this.http
      .get<Expertise>(this.basePath + '/v1/expertises/' + id + "?expand=full_country,invoicesOut,invoicesIn,collaborateurs,collaborateurs.user,type,contact,address,baseUser,satelliteUser,prestations,prestations.user,workflow,prestations.workflow,prestations.type,consignments,total_invoiced")
      .pipe(
        map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }
  saveConsignment(id: number, c: any): Observable<any> {
    if(c.id ) {
      return this.http
      .put<any>(this.basePath + '/v1/consignments/' + c.id, {
        ...c,
        expertise_id: id,
        date_consignment: moment(c.date_consignment).format('YYYY-MM-DD')
      })
      .pipe(
        catchError(this.handleError)
      );
    }
    return this.http
    .post<any>(this.basePath + '/v1/consignments', {
      ...c,
      expertise_id: id,
      date_consignment: moment(c.date_consignment).format('YYYY-MM-DD')
    })
    .pipe(
      catchError(this.handleError)
    );

  }
  deleteConsignment(id: number): Observable<any> {
      return this.http
      .delete<any>(this.basePath + '/v1/consignments/' + id)
      .pipe(
        catchError(this.handleError)
      );
  }

  userTotals(id: number): Observable<any[]> {
    return this.http
      .get<any[]>(this.basePath + '/v1/expertises/prestation/' + id + '?expand=user' )
      .pipe(
        //map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }
  totalAchat(id: number): Observable<any[]> {
    return this.http
      .get<any[]>(this.basePath + '/v1/expertises/achat/' + id + '?expand=user' )
      .pipe(
        //map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }
  save(expertise: any): Observable<Expertise> {
    if (!expertise || expertise.id < 0 ) {
      return this.http
        .post<Expertise>(this.basePath + '/v1/expertises?expand=full_country,collaborateurs,invoicesOut,invoicesIn,collaborateurs.user,type,contact,address,baseUser,satelliteUser,prestations,prestations.user,workflow,prestations.workflow,prestations.type,consignments', expertise)
        .pipe(
          map((o: any) => Object.assign((new Expertise), o)),
          catchError(this.handleError)
        );

    }
    return this.http
      .put<Expertise>(this.basePath + '/v1/expertises/' + expertise.id+ "?expand=full_country,invoicesOut,invoicesIn,collaborateurs,collaborateurs.user,type,contact,address,baseUser,satelliteUser,prestations,prestations.user,workflow,prestations.workflow,prestations.type,consignments", expertise)
      .pipe(
        map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }
  delete(id: number): Observable<any> {
    return this.http
      .delete<any>(this.basePath + '/v1/expertises/' + id)
      .pipe(
        catchError(this.handleError)
      );
  }
  doWorkflow(expertiseId: number, action: string): Observable<Expertise> {
    return this.http
      .put<Expertise>(this.basePath + '/v1/expertises/workflow/' + expertiseId+ "?expand=full_country,invoicesOut,invoicesIn,collaborateurs,collaborateurs.user,type,contact,address,baseUser,satelliteUser,prestations,prestations.user,workflow,prestations.workflow,prestations.type",
        {action: action})
      .pipe(
        map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }
  addAcompte(expertiseId: number, acompte: number): Observable<Expertise> {
    return this.http
      .put<Expertise>(this.basePath + '/v1/expertises/acompte/' + expertiseId+ "?expand=full_country,invoicesOut,invoicesIn,collaborateurs,collaborateurs.user,type,contact,address,baseUser,satelliteUser,prestations,prestations.user,workflow,prestations.workflow,prestations.type",
        {acompte: acompte})
      .pipe(
        map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }
  nextNumber(): Observable<number> {
    return this.http
      .get<number>(this.basePath + '/v1/expertise/next-number' )
      .pipe(
        //map((o: any) => Object.assign((new Expertise), o)),
        catchError(this.handleError)
      );
  }

}
